import { atomHelpers } from '@approvalmax/utils';

export const hideHelpStripeState = atomHelpers.createAtomWithStorage<string[]>('HelpStripe_hideIds', []);
